module.exports = __webpack_public_path__ + "img/step6-en.8839d539.png";